import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6edd77b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Lojas", -1))
const _hoisted_4 = { class: "d-flex flex-column gap-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Placa", -1))
const _hoisted_6 = { class: "d-flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "ID do atendimento", -1))
const _hoisted_8 = { class: "d-flex flex-column gap-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Veículo", -1))
const _hoisted_10 = { class: "d-flex flex-column gap-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Status", -1))
const _hoisted_12 = { class: "d-flex flex-column gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Responsável", -1))
const _hoisted_14 = { class: "d-flex flex-column gap-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Data/Horário", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_FilterBase = _resolveComponent("FilterBase")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "attendance-filter",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    openModal: _ctx.preencheFiltro,
    onSearch: _ctx.enviarEmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.storeId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_el_select, {
                "collapse-tags": "",
                filterable: "",
                placeholder: "Selecione...",
                clearable: "",
                multiple: "",
                modelValue: _ctx.attendanceFilter.codConcessionariaTeste,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attendanceFilter.codConcessionariaTeste) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (loja, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: key,
                      label: loja.nome,
                      value: loja.codConcessionaria
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.attendanceFilter.placa,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.attendanceFilter.placa) = $event))
          }, null, 8, ["modelValue"]), [
            [_directive_maska, {
            mask: 'AAA-****',
            tokens: { '*': { pattern: /[a-zA-Z0-9]/, uppercase: true } },
          }]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.attendanceFilter.idAtendimento,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.attendanceFilter.idAtendimento) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.attendanceFilter.veiculo,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.attendanceFilter.veiculo) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_select, {
            clearable: "",
            placeholder: "Selecione...",
            modelValue: _ctx.attendanceFilter.status,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.attendanceFilter.status) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusAttendance, (status, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: status,
                  value: status
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_el_input, {
            clearable: "",
            placeholder: "Digite...",
            modelValue: _ctx.attendanceFilter.responsavel,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.attendanceFilter.responsavel) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.attendanceFilter.data,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.attendanceFilter.data) = $event)),
                type: "daterange",
                format: "DD/MM/YYYY",
                class: "w-100",
                style: {"border":"1.5px solid #dbdbdb","border-radius":"4px","height":"36px"},
                "start-placeholder": "inicial",
                "end-placeholder": "final",
                "default-value": [new Date(), new Date()]
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }, 8, ["locale"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal", "openModal", "onSearch"]))
}